import { Alert, Button } from 'callahan-react'
import React from 'react'

import DevKeysTable from './DevKeysTable'

export const DeveloperKeys = ({
  developerKeyError,
  displayData,
  loading,
  onClick,
  showDevData
}) => (
  <div>
    <div className="ui-header ui-header-container">
      <h2 className="ui-account-header">Account Developer Keys</h2>
      {!showDevData && (
        <Button onClick={onClick} loading={loading}>
          Create new key
        </Button>
      )}
    </div>
    {showDevData && <DevKeysTable displayData={displayData} />}

    {developerKeyError && (
      <div className="ui-error-alert-devkey">
        <Alert
          color="error"
          title={
            developerKeyError.data && developerKeyError.data.message
              ? developerKeyError.data.message
              : 'There was a problem creating your API key'
          }
        />
      </div>
    )}
  </div>
)

export default DeveloperKeys



// WEBPACK FOOTER //
// ./src/pages/UserInfo/DeveloperKeys.js